/* ── WORK_TRACK — Entry ─────────────────────────────────────
   Imports every feature module so each registers its view and
   wires its handlers, then boots the app.
   ─────────────────────────────────────────────────────────── */

import './core';
import './auth';
import './tailwind.css';
import './dashboard';
import './board';
import './team';
import './timer';
import './projects';
import './entries';
import './composer';
import './chat';
import './meet';
import './mentions';

import { state, api, initTheme, showAuth, showApp } from './core';
import { setBootOwner, setRegister, setResetToken, inviteFromUrl, urlParams } from './auth';
import { mountAuth } from './auth-react';
import { startActiveTimer } from './timer';
import { refreshUnread } from './mentions';
import { refreshUnreadChats } from './chat';
import type { User } from './types';

async function boot(): Promise<void> {
  mountAuth();
  initTheme();
  const resetToken = urlParams.get('reset') || '';
  if (resetToken) {
    setResetToken(resetToken);
    showAuth();
    return;
  }
  const saved = localStorage.getItem('wt_token');
  if (saved) {
    state.token = saved;
    try {
      const d = await api<{ user: User }>('/api/auth/me');
      state.user = d.user;
      showApp();
      startActiveTimer();
      refreshUnread();
      refreshUnreadChats();
      return;
    } catch {
      state.token = null;
      localStorage.removeItem('wt_token');
    }
  }
  showAuth();
  try {
    const status = await api<{ has_users: boolean }>('/api/auth/status');
    if (!status.has_users) {
      setBootOwner(true);
      setRegister(true, { boot: true });
    } else {
      setBootOwner(false);
      setRegister(!!inviteFromUrl, { boot: false, invite: inviteFromUrl });
    }
  } catch {
    setBootOwner(false);
    setRegister(!!inviteFromUrl, { boot: false, invite: inviteFromUrl });
  }
}

boot();
